import React from 'react';

import { IconX } from '@veneer/core';

import { PrinterFeatures } from './types';
import {
  CircleIconContainer,
  FeatureInfoWrapper,
  FeatureName,
  FeatureNumber,
  FeatureUnit,
} from './styles';

interface PrinterFeatureProps {
  features?: PrinterFeatures[];
  featureKey: string;
}

const PrinterFeature: React.FC<PrinterFeatureProps> = ({
  features,
  featureKey,
}) => {
  if (!features) {
    return (
      <FeatureUnit>
        <IconX size={28} filled={false} data-testid="icon-x" />
      </FeatureUnit>
    );
  }

  const feature = features.find((f) => f.id === featureKey);

  if (!feature) {
    return (
      <FeatureUnit>
        <IconX size={28} filled={false} data-testid="icon-x" />
      </FeatureUnit>
    );
  }

  return (
    <FeatureUnit>
      <FeatureInfoWrapper>
        {typeof feature.value === 'number' && feature.value > 0 && (
          <CircleIconContainer>
            <FeatureNumber className="body-large">
              {feature.value}
            </FeatureNumber>
          </CircleIconContainer>
        )}
        {typeof feature.value === 'string' && (
          <div className="caption-regular">{feature.value}</div>
        )}
        <FeatureName className="caption-regular">{feature.name}</FeatureName>
      </FeatureInfoWrapper>
    </FeatureUnit>
  );
};

export default PrinterFeature;
